<div
  class="alienala-loader-container"
  [class.fullscreen]="fullscreen"
  [class.size-small]="size === 'small'"
  [class.size-medium]="size === 'medium'"
  [class.size-large]="size === 'large'"
>
  <div class="loader-content">
    <div class="logo-container">
      <svg
        class="alienala-logo-animated"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="64" height="64" rx="12" fill="#d92518" />

        <!-- Assiette -->
        <circle class="plate-circle" cx="32" cy="35" r="14" fill="#fff8ea" />

        <!-- Fourchette -->
        <g class="fork-animate" transform="translate(22, 18)">
          <rect x="0" y="0" width="1.5" height="20" fill="#d92518" rx="0.5" />
          <rect x="3" y="0" width="1.5" height="20" fill="#d92518" rx="0.5" />
          <rect x="6" y="0" width="1.5" height="20" fill="#d92518" rx="0.5" />
          <rect x="0" y="0" width="7.5" height="5" fill="#d92518" rx="1" />
        </g>

        <!-- Couteau -->
        <g class="knife-animate" transform="translate(36, 18)">
          <rect x="0" y="0" width="2" height="20" fill="#d92518" rx="0.5" />
          <path d="M 0 0 L 2 0 L 2 7 L 1 9 L 0 7 Z" fill="#d92518" />
        </g>

        <circle class="accent-pulse" cx="48" cy="16" r="4" fill="#eeb015" />
      </svg>

      <!-- Cercle de progression -->
      <svg class="progress-circle" viewBox="0 0 80 80">
        <circle
          class="progress-ring"
          cx="40"
          cy="40"
          r="36"
          stroke="url(#gradient-progress)"
          stroke-width="3"
          fill="none"
          stroke-linecap="round"
        />
        <defs>
          <linearGradient
            id="gradient-progress"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" style="stop-color: #d92518; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #eeb015; stop-opacity: 1" />
          </linearGradient>
        </defs>
      </svg>
    </div>

    @if (message) {
      <p class="loader-message">{{ message }}</p>
    }

    <!-- Indicateur de chargement animé -->
    <div class="loading-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>
</div>
